@if (tree(); as tree) {
  @let open = coordinator.isNavigationOpen();
  <nav class="nav-dropdown" role="navigation" aria-label="Hauptnavigation">
    <div role="group" class="basic-tree">
      <a
        [tabindex]="open ? '0' : '-1'"
        uiVibrate
        class="nm-button nav-dropdown-item"
        title="Startseite"
        aria-label="Startseite"
        [routerLinkActiveOptions]="{ exact: true }"
        routerLinkActive="nm-active fill"
        routerLink="/">
        <span class="before nav-title" size="lg" uiIcon="home">Startseite</span>
      </a>
      <ng-template
        [ngTemplateOutlet]="treeNodes"
        [ngTemplateOutletContext]="{ children: tree.children, parent: tree.parent }" />
      <a
        [tabindex]="open ? '0' : '-1'"
        uiVibrate
        class="nm-button nav-dropdown-item"
        title="Einstellungen"
        aria-label="Einstellungen"
        [routerLinkActiveOptions]="{ exact: true }"
        routerLinkActive="nm-active fill"
        routerLink="/controls">
        <span class="before nav-title" size="lg" uiIcon="handyman">Einstellungen</span>
      </a>
    </div>
  </nav>

  <ng-template #treeNodes let-children="children" let-parent="parent">
    @for (child of children; track child.page.id) {
      @if (child.children?.length) {
        <div class="nav-group">
          <div
            role="button"
            [tabindex]="open ? '0' : '-1'"
            uiVibrate
            [attr.data-id]="child.page.id"
            class="nm-button nav-dropdown-toggle nm-has-active"
            [attr.aria-expanded]="isExpanded(child.page.id) ? 'true' : 'false'"
            [attr.aria-label]="child.page.title">
            <div class="toggle-wrapper">
              <span
                size="lg"
                uiIcon="keyboard_arrow_down"
                class="after nav-toggle-icon"
                [attr.data-open]="isExpanded(child.page.id) ? 'true' : 'false'">
              </span>
              <span class="before nav-prefix" size="lg">
                {{ groupLabel(child.page.title) }}
              </span>
              @if (child.page.isNew) {
                <div class="relative">
                  <span class="is-new fill" uiIcon="stat_3"></span>
                </div>
              }
            </div>
            @if (isExpanded(child.page.id)) {
              <div role="group">
                <a
                  [tabindex]="open ? '0' : '-1'"
                  uiVibrate
                  class="nm-button nav-dropdown-item before"
                  size="lg"
                  [title]="child.page.title + (child.page.isNew ? ' (update)' : '')"
                  [attr.aria-label]="child.page.title + (child.page.isNew ? ' (update)' : '')"
                  routerLinkActive="nm-active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [routerLink]="child.page.route || '/'">
                  <span uiIcon="book_2" class="before nav-title" size="lg">
                    {{ child.parent ? removeLabel(child.page.title) : child.page.title }}
                  </span>
                  @if (child.page.isNew) {
                    <div class="relative">
                      <span class="is-new fill" uiIcon="stat_3"></span>
                    </div>
                  }
                </a>

                <ng-template
                  [ngTemplateOutlet]="treeNodes"
                  [ngTemplateOutletContext]="{ children: child.children, parent: child.parent }" />
              </div>
            }
          </div>
        </div>
      } @else {
        <a
          [tabindex]="open ? '0' : '-1'"
          uiVibrate
          class="nm-button nav-dropdown-item before"
          size="lg"
          [title]="child.page.title + (child.page.isNew ? ' (update)' : '')"
          [attr.aria-label]="child.page.title + (child.page.isNew ? ' (update)' : '')"
          routerLinkActive="nm-active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="child.page.route || '/'">
          <span uiIcon="book_2" class="before nav-title" size="lg">
            {{ child.parent ? removeLabel(child.page.title) : child.page.title }}
          </span>
          @if (child.page.isNew) {
            <div class="relative">
              <span class="is-new fill" uiIcon="stat_3"></span>
            </div>
          }
        </a>
      }
    }
  </ng-template>
}
